import { IconCypressColor, IconJavaColor, IconWebdriverioColor } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import React from 'react';
import { Link } from '@saucelabs/ds-link';
import { NoData } from '@saucelabs/ds-data-states';

import { GetStartedCard } from './GetStartedCard';

const BuildsGuide = () => (
  <div
    className="flex flex-col items-center justify-center flex-grow px-2"
  >
    <NoData
      className="mb-2"
      description="Get clear and instant visibility into the impact of code changes on your user interface across browsers, devices, and operating systems. Get started in minutes with our quick start guides."
      spacing="large"
      title="Run Your First Visual Test"
    />

    <div className="w-full mt-2 max-w-4xl gap-2 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
      <GetStartedCard
        href="https://github.com/saucelabs/visual-examples/tree/main/wdio"
        icon={IconWebdriverioColor}
        tags={['JavaScript']}
        title="WebdriverIO"
      />
      <GetStartedCard
        href="https://github.com/saucelabs/visual-examples/tree/main/cypress"
        icon={IconCypressColor}
        tags={['JavaScript']}
        title="Cypress"
      />
      <GetStartedCard
        href="https://github.com/saucelabs/visual-examples/tree/main/wd-java"
        icon={IconJavaColor}
        tags={['JUnit', 'TestNG']}
        title="Java"
      />
    </div>
    <div>
      <Typography variant="heading-2">
        Helpful resources
      </Typography>
      <ul className="list-none p-0 m-0 text-center">
        <li>
          <Link
            inline
            isExternal
            to="https://docs.saucelabs.com/web-apps/"
          >
            Get started with Automated Testing
          </Link>
        </li>
        <li>
          <Link
            inline
            isExternal
            to="https://docs.saucelabs.com/visual-testing/sauce-visual/index.html"
          >
            Getting started with Visual Testing
          </Link>
        </li>
        <li>
          <Link
            inline
            isExternal
            to="https://docs.saucelabs.com/secure-connections/sauce-connect/"
          >
            Set up Sauce Connect Proxy
          </Link>
        </li>
      </ul>
    </div>

  </div>
);

export default BuildsGuide;
